import React from "react";
import isEmail from "validator/lib/isEmail";
import Button from "Components/button/Button";
import Input from "Components/input/Input";
import QboxmailApi from "../../../qboxmailApi";
import PasswordGenerator from "Components/PasswordGenerator";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import { pwdCheck } from "Utils/strings";
import { formatServerErrors } from "Utils/serverFormats";
import HelpTooltip from "Components/helpTooltip/HelpTooltip";
import WarningBanner from "Components/warningBanner/WarningBanner";

import cx from "classnames";

class BasicInfoForm extends React.Component {
  constructor(props) {
    super(props);
    this.toggleAdvancedFields = this.toggleAdvancedFields.bind(this);
    this.state = {
      showAdvancedFields: false,
    };
  }

  componentDidMount() {
    this.firstInput.focus();
  }

  toggleAdvancedFields = () => {
    this.setState({ showAdvancedFields: !this.state.showAdvancedFields });
  };

  validate(values) {
    return new Promise((resolve) => {
      let errors = {};
      if (!isEmail(`${values.name}@${this.props.domain.name}`)) {
        errors.name = t("errorMsg.notValid.emailAddress");
      }

      if (!values.firstname) errors.firstname = t("errorMsg.missing.field");

      const pwErrors = pwdCheck(values.password);
      if (pwErrors) errors.password = pwErrors;
      if (values.password !== values.password_confirmation) {
        errors.password_confirmation = t("errorMsg.notMarch.passowrd");
      }
      if (!values.password) errors.password = t("errorMsg.missing.field");
      if (!values.password_confirmation) errors.password_confirmation = t("errorMsg.missing.field");
      if (!values.name) errors.name = t("errorMsg.missing.field");

      const api = new QboxmailApi({ useCookie: true });
      api
        .validateEmailName(this.props.domain.code, values.name)
        .then((response) => {
          if (response.valid) {
            resolve(errors);
          } else {
            errors.name = response.message;
            resolve(errors);
          }
        })
        .catch((response) => {
          formatServerErrors(response).then((e) => {
            this.props.setFormErrors({ ...errors, ...e });
            this.props.unsetFormLoading();
          });
        });
    });
  }

  goToNextStep = (e) => {
    const { setFormLoading, setFormErrors, setDataForm, goToStep, formData } = this.props;
    e.preventDefault();
    setFormLoading();
    this.validate(formData).then((errors) => {
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
      } else {
        setDataForm(this.state.formData);
        goToStep(2);
      }
    });
  };

  fillPasswordFields = (generatedPassword) => {
    this.props.setFormFieldValue({
      password: generatedPassword,
      password_confirmation: generatedPassword,
    });
  };

  submit = (e) => {
    e.preventDefault();
    this.props.submitForm();
  };

  render() {
    const { domain, formData, setFormFieldValue, formErrors, isFormLoading } = this.props;
    const { showAdvancedFields } = this.state;
    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("emailAccounts.add.title.step1")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              <TranslatedString>emailAccounts.add.desc.step1</TranslatedString>
            </div>
            <Button className="btnDocsFP" docsKey="emailAccount_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.submit}>
            <div className="formsFP">
              <Input
                className="inputFull2"
                label={t("input.label.firstName.user")}
                placeholder={t("input.placeholder.firstName")}
                name="firstname"
                errors={formErrors.firstname}
                ref={(input) => (this.firstInput = input)}
                type="text"
                required
                autoComplete="new-password"
                value={formData.firstname}
                onChange={setFormFieldValue}
                helpTooltip={
                  <HelpTooltip
                    children={[
                      {
                        description: t("helpT.addEmailAccounts.emailAccountsName.step1"),
                      },
                    ]}
                  />
                }
              />

              <Input
                className="inputFull2"
                label={t("input.label.lastName.user")}
                placeholder={t("input.placeholder.lastName")}
                name="lastname"
                type="text"
                errors={formErrors.lastname}
                autoComplete="new-password"
                value={formData.lastname}
                onChange={setFormFieldValue}
              />

              <Input
                className={cx("inputFull2", "inputAddMargin")}
                name="name"
                label={t("input.label.email")}
                placeholder={t("input.placeholder.email")}
                type="text"
                value={formData.name}
                trim
                errors={formErrors.name || formErrors.email_address || formErrors.email_name}
                onChange={setFormFieldValue}
                blockedTextEnd={"@" + domain.name}
                autoComplete="new-password"
                autoCapitalize="off"
                required
              />

              {domain.plan.name !== "basic" && (
                <div
                  className={cx("internalLink", "inputFull2", {
                    inputAddMargin: !showAdvancedFields,
                  })}
                  onClick={this.toggleAdvancedFields}
                >
                  {showAdvancedFields ? t("button.advanced.domainInfo.hide") : t("button.advanced.domainInfo.show")}
                </div>
              )}

              {showAdvancedFields && (
                <Input
                  className="inputFull2"
                  name="mobilephone"
                  label={t("input.label.email.mobilephone")}
                  placeholder={t("input.placeholder.mobilephone")}
                  type="text"
                  value={formData.mobilephone}
                  errors={formErrors.mobilephone}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {showAdvancedFields && (
                <Input
                  name="role"
                  label={t("input.label.email.role")}
                  placeholder={t("input.placeholder.role")}
                  type="text"
                  value={formData.role}
                  errors={formErrors.role}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {showAdvancedFields && (
                <Input
                  name="organizational_unit"
                  label={t("input.label.email.organizational_unit")}
                  placeholder={t("input.placeholder.organizational_unit")}
                  type="text"
                  value={formData.organizational_unit}
                  errors={formErrors.organizational_unit}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )}

              {/* {showAdvancedFields && (
                <Input
                  name="city"
                  label={t("input.label.city")}
                  placeholder={t("input.placeholder.city")}
                  type="text"
                  value={formData.city}
                  errors={formErrors.city}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )} */}

              {/* {showAdvancedFields && (
                <Input
                  className={cx("inputAddMargin")}
                  name="state"
                  label={t("input.label.state")}
                  placeholder={t("input.placeholder.state")}
                  type="text"
                  value={formData.state}
                  errors={formErrors.state}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )} */}

              {/* {showAdvancedFields && (
                <Input
                  className={cx("inputAddMargin")}
                  name="country"
                  label={t("input.label.country")}
                  placeholder={t("input.placeholder.country")}
                  type="text"
                  value={formData.country}
                  errors={formErrors.country}
                  onChange={setFormFieldValue}
                  autoComplete="new-password"
                />
              )} */}

              <Input
                className="inputFull2"
                name="password"
                type="password"
                label={t("input.label.password")}
                value={formData.password}
                errors={formErrors.password}
                onChange={setFormFieldValue}
                autoComplete="new-password"
                required
              />

              <Input
                className="inputFull2"
                name="password_confirmation"
                type="password"
                label={t("input.label.passwordConfirm")}
                value={formData.password_confirmation}
                errors={formErrors.password_confirmation}
                onChange={setFormFieldValue}
                autoComplete="new-password"
                required
              />

              <PasswordGenerator className="inputFull2" onNewPassword={this.fillPasswordFields} />
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" loading={isFormLoading} onClick={this.goToNextStep}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default BasicInfoForm;
